import { render, staticRenderFns } from "./PrivilegeBodyTemperature.vue?vue&type=template&id=35e15aee"
import script from "./PrivilegeBodyTemperature.vue?vue&type=script&lang=js"
export * from "./PrivilegeBodyTemperature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports